import React from 'react';
import ComponentHelper from '../../../../supers/ComponentHelper';
import './dashboard-builder.css';
import RoutingService from '../../../../services/RoutingService';
import RESTService from '../../../../services/RESTService';
import Dropdown from '../../../../components/dropdown/Dropdown';
import img1 from '../images/appointments.png';
import img2 from '../images/monthlySales.png';
import img3 from '../images/productCards.png';
import img4 from '../images/quickCards.png';
import img5 from '../images/salesByStore.png';
import img6 from '../images/taskList.png';
import CommonService from '../../../../services/CommonService';
import ListPanel from '../../../../components/list-panel/ListPanel';
import DialogModal from '../../../../components/dialog-modal/DialogModal';
import ComponentEditor from '../../component-editor/ComponentEditor';

const RS = new RoutingService();
const connect = new RESTService();
const CS = new CommonService();

class DashboardBuilder extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			config: null,
			selectedTab: '',
			activeTab: null,
			selectedLayout: 'column',
			selectedCmp: '',
			toEdit: {},
			toDelete: null,
			unsavedChanges: false,
			expandedCmp: null,
			cmpOpen: false,
			showDeleteModal: false,
			showEditModal: false
		};
		this.autoBind([
			'onTabChange',
			'getDashboardTabs',
			'onLayoutChange',
			'onSelectedCmpChange',
			'getCmpImage',
			'addToInterface',
			'onSaveTab',
			'getWidgets',
			'buildCMPCards',
			'onCmpClick',
			'onEdit',
			'onDelete',
			'moveUp',
			'moveDown',
			'toggleDeleteModal',
			'onConfirmDelete',
			'onCloseEditModal',
			'onSaveComponent',
			'onCompletedChange'
		]);
	}

	onConfirmDelete() {
		let key = this.data.toDelete;
		let cfg = this.data.config;
		let tab = cfg.dashboard.tabs[this.data.selectedTab];
		if (tab && tab.widgets[key]) {
			let removing = tab.widgets[key].order;
			delete tab.widgets[key];
			let widgets = Object.values(tab.widgets);
			if (widgets.length > 0) {
				for (let i = 0; i < widgets.length; i++) {
					if (widgets[i].order > removing) {
						widgets[i].order--;
					}
				}
			}
			cfg.dashboard.tabs[this.data.selectedTab] = tab;
			this.data.config = cfg;
			this.data.toDelete = null;
			this.data.showDeleteModal = false;
			this.onSaveTab();
		}
	}

	toggleDeleteModal() {
		this.setData('showDeleteModal', !this.data.showDeleteModal);
	}

	onDelete(evt) {
		let key = evt.currentTarget.dataset.key;
		if (key) {
			this.observe(() => {
				this.data.showDeleteModal = true;
				this.data.toDelete = key;
			});
		}
	}

	onSaveTab() {
		let path = `dashboard.tabs.${this.data.selectedTab}`;
		let current = this.data.config.dashboard.tabs[this.data.selectedTab];
		if (current) {
			current.columnView = this.data.selectedLayout === 'column' ? true : false;
			connect
				.updateAppConfigSegment(path, current)
				.then(res => {
					this.setData('config', res.data);
					RS.showSuccess();
				})
				.catch(err => {
					console.log(err.response.data);
				});
		}
	}

	onCompletedChange(config) {
		this.setData('config', config);
	}

	componentDidMount() {
		let config = RS.getCurrentConfiguration();
		connect
			.getAppConfig({
				_id: config._id,
				name: config.name,
				version: config.version
			})
			.then(res => {
				RS.setCurrentConfiguration(res.data);
				this.observe(() => {
					this.data.config = res.data;
					let dash = res.data.dashboard;
					let tabs = Object.values(dash.tabs);
					if (tabs.length > 0) {
						this.data.selectedTab = tabs[0].id;
						this.data.activeTab = tabs[0];
						this.data.selectedLayout = tabs[0].columnView ? 'column' : 'row';
					}
					let aCmps = dash.availableComponents;
					if (aCmps.length > 0) {
						this.data.selectedCmp = aCmps[0];
					}
				});
			})
			.catch(err => {
				console.log(err.data);
			});
	}

	onTabChange(val) {
		this.observe(() => {
			this.data.selectedTab = val.value;
			this.data.activeTab = this.data.config.dashboard.tabs[val.value];
			this.data.selectedLayout = this.data.activeTab.columnView ? 'column' : 'row';
		});
	}

	onLayoutChange(val) {
		this.observe(() => {
			this.data.selectedLayout = val.value;
			this.onSaveTab();
		});
	}

	onSelectedCmpChange(val) {
		this.observe(() => {
			this.data.selectedCmp = val.value;
		});
	}

	addToInterface() {
		let cfg = this.data.config;
		let cmp = cfg.UIComponents[this.data.selectedCmp];
		let tab = cfg.dashboard.tabs[this.data.selectedTab];
		if (cmp && tab) {
			let newCmp = JSON.parse(JSON.stringify(cmp));
			newCmp.key = CS.UUID();
			newCmp.order = Object.keys(tab.widgets).length + 1;
			cfg.dashboard.tabs[this.data.selectedTab].widgets[newCmp.key] = newCmp;
			this.data.config = cfg;
			this.onSaveTab();
		}
	}

	getDashboardTabs() {
		let tabs = [];
		let existing = this.data.config ? this.data.config.dashboard.tabs : {};
		let vals = Object.values(existing);
		vals.forEach(tab => {
			tabs.push({
				label: tab.name,
				value: tab.id
			});
		});
		return tabs;
	}

	getAvailableComponents() {
		let cmps = [];
		if (this.data.config) {
			let dash = this.data.config.dashboard;
			let aCmps = dash.availableComponents;
			aCmps.forEach(available => {
				cmps.push({
					label: available,
					value: available
				});
			});
		}
		return cmps;
	}

	getCmpImage(cmp) {
		switch (cmp) {
			case 'appointments': {
				return img1;
			}
			case 'salesByStore': {
				return img5;
			}
			case 'quickCards': {
				return img4;
			}
			case 'salesMetrics': {
				return img2;
			}
			case 'tasks': {
				return img6;
			}
			case 'products': {
				return img3;
			}
			default: {
				return img3;
			}
		}
	}

	getWidgets() {
		if (this.data.config && this.data.selectedTab.length > 0) {
			let widgets = this.data.config.dashboard.tabs[this.data.selectedTab].widgets;
			if (widgets) {
				return Object.values(widgets);
			}
		}
		return [];
	}

	onCloseEditModal() {
		this.setData('showEditModal', false);
	}

	onSaveComponent(cmp) {
		let path = `dashboard.tabs.${this.data.selectedTab}.widgets.${cmp.key}`;
		return connect.updateAppConfigSegment(path, cmp);
	}

	onEdit(evt) {
		let key = evt.currentTarget.dataset.key;
		if (key) {
			this.observe(() => {
				this.data.showEditModal = true;
				this.data.toEdit = this.data.config.dashboard.tabs[this.data.selectedTab].widgets[key];
			});
		}
	}

	reorder = (key, up) => {
		let cfg = this.data.config;
		let tab = cfg.dashboard.tabs[this.data.selectedTab];
		if (tab && tab.widgets[key]) {
			let moving = tab.widgets[key].order;
			let widgets = Object.values(tab.widgets);
			for (let i = 0; i < widgets.length; i++) {
				if (up) {
					if (widgets[i].order === moving - 1) {
						widgets[i].order++;
					}
				} else {
					if (widgets[i].order === moving + 1) {
						widgets[i].order--;
					}
				}
			}
			if (up) {
				tab.widgets[key].order--;
			} else {
				tab.widgets[key].order++;
			}
			cfg.dashboard.tabs[this.data.selectedTab] = tab;
			this.data.config = cfg;
			this.onSaveTab();
		}
	};

	moveUp(evt) {
		let key = evt.currentTarget.dataset.key;
		this.reorder(key, true);
	}

	moveDown(evt) {
		let key = evt.currentTarget.dataset.key;
		this.reorder(key, false);
	}

	onCmpClick(evt) {
		if (evt.target.classList.contains('action') || evt.target.classList.contains('mdi')) {
			return;
		}
		let key = evt.currentTarget.dataset.key;
		if (key && this.data.expandedCmp !== key) {
			this.observe(() => {
				this.data.expandedCmp = key;
				this.data.cmpOpen = '';
			});
			setTimeout(() => {
				this.setData('cmpOpen', 'open');
			}, 100);
		} else if (key) {
			this.setData('cmpOpen', 'close');
			setTimeout(() => {
				this.observe(() => {
					this.data.expandedCmp = null;
					this.data.cmpOpen = '';
				});
			}, 200);
		}
	}

	getExpandedCmp(cmp) {
		if (this.data.expandedCmp === cmp.key) {
			return (
				<div className={`cmp-details ${this.data.cmpOpen}`} key={'details-key-' + cmp.key}>
					<div className="component-body vbox center vcenter">
						<pre>{JSON.stringify(cmp, undefined, 2)}</pre>
					</div>
				</div>
			);
		}
		return '';
	}

	buildCMPCards() {
		let cmps = [];
		let widgets = this.getWidgets();
		let expanded = this.data.expandedCmp;
		widgets.sort(function(a, b) {
			return a.order - b.order;
		});
		for (let i = 0; i < widgets.length; i++) {
			let cmp = widgets[i];
			cmps.push([
				<div
					className="dashboard-component-card list-item animated fadeInRight hbox vcenter"
					key={cmp.key}
					data-key={cmp.key}
					onClick={this.onCmpClick}
				>
					{widgets.length > 1 && (
						<div className="vbox vcenter hcenter order-options">
							{cmp.order !== 1 ? (
								<i className="mdi mdi-arrow-up-bold-circle-outline" title="Move Up" data-key={cmp.key} onClick={this.moveUp} />
							) : (
								<div className="spacer" />
							)}
							{cmp.order !== widgets.length && (
								<i className="mdi mdi-arrow-down-bold-circle-outline" title="Move Down" data-key={cmp.key} onClick={this.moveDown} />
							)}
						</div>
					)}
					<img src={this.getCmpImage(cmp.name)} className="list-img" alt="Component" />
					<div className="name ellipse hbox vcenter grow-1">
						{cmp.name}
						<div className="key-line ellipse" title={cmp.key}>
							key:{cmp.key}
						</div>
					</div>
					<div className="grow-1" />
					<div className="grow-1" />
					<div className="actions hbox vcenter grow-1">
						<div className="action vbox hcenter vcenter" data-rh="Configure" data-rh-at="top" data-key={cmp.key} onClick={this.onEdit}>
							<i className="mdi mdi-wrench" data-key={cmp.key} />
						</div>
						<div className="action vbox hcenter vcenter" data-rh="Delete" data-rh-at="top" data-key={cmp.key} onClick={this.onDelete}>
							<i className="mdi mdi-delete" data-key={cmp.key} />
						</div>
						<i className={`mdi mdi-chevron-${expanded && expanded === cmp.key ? 'up' : 'down'}`} />
					</div>
				</div>,
				this.getExpandedCmp(cmp)
			]);
		}
		if (cmps.length <= 0) {
			cmps.push(
				<div className="empty-list" key={'empty-text-1'}>
					There are no components inside of this tab.
				</div>
			);
		}
		return cmps;
	}

	render() {
		let { selectedTab, selectedLayout, selectedCmp, config, unsavedChanges, showDeleteModal, showEditModal, toEdit } = this.data;
		return (
			<div className={`dashboard-builder-view hbox animated fadeIn ${showEditModal ? 'blur' : ''}`}>
				<div className="options-container panel">
					<div className="active-tab-ctn hbox vcenter">
						<Dropdown
							className="active-tab-picker"
							label="Select a dashboard tab to configure"
							value={selectedTab}
							handleChange={this.onTabChange}
							name="selectedTab"
							options={this.getDashboardTabs()}
						/>
					</div>
					<Dropdown
						className="tab-layout-picker"
						label="Select the tab layout"
						value={selectedLayout}
						handleChange={this.onLayoutChange}
						name="selectedLayout"
						options={[
							{
								value: 'column',
								label: 'Column'
							},
							{
								value: 'row',
								label: 'Row'
							}
						]}
					/>
					<div className="components-picker-ctn hbox vcenter">
						<Dropdown
							className="component-picker"
							label="Available UI Components"
							value={selectedCmp}
							handleChange={this.onSelectedCmpChange}
							name="selectedLayout"
							options={this.getAvailableComponents()}
						/>
						<button className="btn primary square vbox hcenter vcenter" data-rh="Add to Interface" data-rh-at="top" onClick={this.addToInterface}>
							<i className="mdi mdi-arrow-right" />
						</button>
					</div>
					<div className="component-image vbox hcenter vcenter shadow grow-1">
						<img
							className={`cmp-img animated flipInX ${selectedCmp}`}
							src={this.getCmpImage(selectedCmp)}
							key={selectedCmp + 'img-key'}
							alt="Component"
						/>
					</div>
				</div>
				{config && (
					<div className="component-configuration-ctn panel animated fadeIn">
						<ListPanel
							name={`${config.dashboard.tabs[selectedTab].name} Tab Components`}
							className="component-list-view"
							labels={['Active Components', '', '', 'actions']}
							listItems={this.buildCMPCards()}
							headerItems={<button className={`btn primary small m-r-10 animated zoomIn ${!unsavedChanges ? 'hidden' : ''}`}>Save</button>}
						/>
						<DialogModal
							isOpen={showDeleteModal}
							type="warning"
							showCancelButton={true}
							cancelBtnText="Cancel"
							confirmBtnText="Delete"
							text="Deleting a component cannot be undone"
							title="Are you sure?"
							onConfirm={this.onConfirmDelete}
							onCancel={this.toggleDeleteModal}
						/>
						<ComponentEditor
							isOpen={showEditModal}
							toEdit={toEdit}
							onSave={this.onSaveComponent}
							onClose={this.onCloseEditModal}
							onCompleted={this.onCompletedChange}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default DashboardBuilder;



// WEBPACK FOOTER //
// ./src/views/app-composer/concierge/dashboard-builder/DashboardBuilder.js